export enum EPages {
    HOMEPAGE = 'homepage',
    OPERATION_ECOMMERCE = 'operationEcommerce',
    REFUND_POLICY = 'refundPolicy'
}